'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const LaserFlow = dynamic(() => import('./laser-flow').then((m) => m.LaserFlow), { ssr: false });

/** Renderiza o LaserFlow (WebGL) só em telas md+ e sem prefers-reduced-motion.
 *  Caso contrário, um glow estático leve (sem WebGL) no lugar do feixe. */
export function LaserFlowBg() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const wide = window.matchMedia('(min-width: 768px)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = (): void => setEnabled(wide.matches && !reduce.matches);
    update();
    wide.addEventListener('change', update);
    reduce.addEventListener('change', update);
    return () => {
      wide.removeEventListener('change', update);
      reduce.removeEventListener('change', update);
    };
  }, []);

  if (!enabled) {
    return (
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute top-0 left-[58%] h-1/2 w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-[#b79bff] to-[#9061ff]" />
        <div className="absolute top-1/2 left-[58%] h-56 w-[60%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(144,97,255,0.45),transparent)] blur-2xl" />
      </div>
    );
  }

  return (
    <LaserFlow
      className="absolute inset-0"
      color="#9061FF"
      horizontalBeamOffset={0.08}
      verticalBeamOffset={0}
      fogIntensity={0.28}
    />
  );
}

export default LaserFlowBg;
